"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortDirection = void 0;
exports.naturalSortByProperty = naturalSortByProperty;
exports.sortByProperty = sortByProperty;

var _orderBy = _interopRequireDefault(require("lodash/fp/orderBy"));

var _naturalOrderby = require("natural-orderby");

var SortDirection = {
  ASCENDING: 'asc',
  DESCENDING: 'desc'
};
exports.SortDirection = SortDirection;

var toLowerCaseProp = function toLowerCaseProp(element, prop) {
  if (typeof element[prop] === 'string') {
    return element[prop].toLowerCase();
  }

  return element[prop];
};

function sortByProperty(array, property) {
  var sortDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SortDirection.ASCENDING;
  var isCaseSensitiv = arguments.length > 3 ? arguments[3] : undefined;

  if (!isCaseSensitiv) {
    return (0, _orderBy.default)(function (element) {
      return toLowerCaseProp(element, property);
    }, sortDirection, array);
  }

  return (0, _orderBy.default)(property, sortDirection, array);
}

function naturalSortByProperty(array, property) {
  var sortDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SortDirection.ASCENDING;
  var isCaseSensitiv = arguments.length > 3 ? arguments[3] : undefined;

  if (!isCaseSensitiv) {
    return (0, _naturalOrderby.orderBy)(array, function (element) {
      return toLowerCaseProp(element, property);
    }, sortDirection);
  }

  return (0, _naturalOrderby.orderBy)(array, property, sortDirection);
}